import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import Global from '../../../../../store/global-selectors';
import getDisplayInformation from '../../../../../components/data-driven-logo/get-display-information';
import { useTaxIdentifiers } from '../../../../../hooks/use-tax-identifier';
import { getVisiblePackingSlips } from '../../../../../hooks/use-visible-packing-slips';

// Create selector outside the component - this is memoized across all hook calls
const automationRuleEntitiesSelector = createSelector(
  (state) => Global.selectSellerTags(state),
  (state) => Global.selectReferenceDatagetSellerCarriers(state),
  (state) => Global.selectSellerServices(state),
  (state) => Global.selectSellerPackages(state),
  (state) => Global.selectSellerShipFroms(state),
  (state) => Global.selectSellerActiveStores(state),
  (state) => Global.selectReferenceDatagetMarketplaces(state),
  (state) => Global.selectSellerActiveUsers(state),
  (state) => Global.selectSellerActiveFulfillmentProviders(state),
  (state) => Global.selectSellerLabelProviders(state),
  (state) => Global.selectSellerInventoryWarehouses(state),
  (state) => getVisiblePackingSlips(state),
  (state) => Global.selectSellerServiceCollections(state),
  (state) => Global.selectReferenceDatagetStates(state),
  (
    tags,
    rawCarriers,
    carrierServices,
    packageTypes,
    shipFroms,
    stores,
    marketplaces,
    users,
    fulfillmentProviders,
    shippingAccounts,
    warehouses,
    packingSlips,
    serviceCollections,
    states,
  ) => {
    const carriers = (rawCarriers || []).map((carrier) => {
      const displayInfo = getDisplayInformation({ carrierId: Number.parseInt(carrier.carrierId, 10) });
      return {
        ...carrier,
        name: displayInfo?.name || `Carrier ${carrier.carrierId}`,
      };
    });

    return {
      tags: tags || [],
      carriers,
      carrierServices: carrierServices || [],
      fulfillmentProviders: fulfillmentProviders || [],
      marketplaces: marketplaces || [],
      packageTypes: packageTypes || [],
      packingSlips: packingSlips || [],
      serviceCollections: serviceCollections || [],
      shipFroms: shipFroms || [],
      shippingAccounts: shippingAccounts || [],
      states: states || [],
      stores: stores || [],
      users: users || [],
      warehouses: warehouses || [],
    };
  },
);

export const useAutomationRuleEntities = () => {
  const entitiesFromSelector = useSelector(automationRuleEntitiesSelector);
  const { taxIdentifiers } = useTaxIdentifiers({ includeInactive: false });

  const automationRuleData = useMemo(
    () => ({
      ...entitiesFromSelector,
      taxIdentifiers,
    }),
    [entitiesFromSelector, taxIdentifiers],
  );

  return {
    tags: entitiesFromSelector.tags,
    automationRuleData,
  };
};
